import axios from 'axios';

const acceptPolicy = () => axios.put('voice-call/settings/accept');
const updateSettings = params => axios.put('voice-call/settings', params);

export { acceptPolicy, updateSettings };